import { render } from "./FacilityGeoPointModal.vue?vue&type=template&id=8054b38e&scoped=true&ts=true"
import script from "./FacilityGeoPointModal.vue?vue&type=script&lang=ts"
export * from "./FacilityGeoPointModal.vue?vue&type=script&lang=ts"

import "./FacilityGeoPointModal.vue?vue&type=style&index=0&id=8054b38e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8054b38e"]])

export default __exports__